import { PDFDocument } from 'pdf-lib';

/**
 * Merge PDF files in order, preserving page content where possible.
 * @param {File[]} files
 * @param {(fileIndex: number, fileTotal: number) => void} [onProgress]
 * @returns {Promise<Blob>}
 */
export async function mergePdfFiles(files, onProgress) {
    const merged = await PDFDocument.create();

    for (let i = 0; i < files.length; i++) {
        onProgress?.(i + 1, files.length);
        const bytes = await files[i].arrayBuffer();
        let pdf;
        try {
            pdf = await PDFDocument.load(bytes, { ignoreEncryption: true });
        } catch (err) {
            if (String(err?.message || '').toLowerCase().includes('encrypt')) {
                throw new Error('password');
            }
            throw err;
        }

        const indices = pdf.getPageIndices();
        const pages = await merged.copyPages(pdf, indices);
        for (const page of pages) merged.addPage(page);
    }

    const output = await merged.save();
    return new Blob([output], { type: 'application/pdf' });
}
